import { securedAxios } from "../lib/axios";
import { unmaskCPF } from "../lib/masks";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    fornecedores: [],
  },
  mutations: {
    carregar(state, lista) {
      state.fornecedores = [];
      state.fornecedores = lista;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/fornecedores?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, data) {
      try {
        let response;
        const dados = {
          ...data,
          cpf_cnpj: unmaskCPF(data.cpf_cnpj),
        };
        if (data.id === "") {
          delete dados.id;
          response = await securedAxios.post("/fornecedores", dados);
        } else {
          delete dados.id_entidade;
          response = await securedAxios.put(`/fornecedores/${data.id}`, dados);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregar(context, id) {
      return securedAxios.get(`/fornecedores/${id}`);
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete(`/fornecedores/${id}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
